<!-- CARD FORM TEMPLATE -->
<div class="card-form">
    <ng-template #requiredErrorTip>
        - This field is required
    </ng-template>

    <!-- ----------------------------------------------------------------------- -->
    <!--                               Health Card                               -->
    <!-- ----------------------------------------------------------------------- -->
    <div class="health-card-container" [ngClass]="hcType">
        <img class="bg-logo" src="assets/ontario-logo-img.png" />

        <!-- ----------------------------- card header ----------------------------- -->

        <div class="hc-header">
            <ng-container *ngIf="hcType === 'Ontario'">
                <img src="assets/ontario-logo.png" />
                <h4>Health Card</h4>
            </ng-container>
            <ng-container *ngIf="hcType === 'Non-Ontario'">
                <h4>Non-Ontario Health Card</h4>
            </ng-container>
        </div>

        <!-- ------------------------------ card body ------------------------------ -->

        <div class="hc-body">
            <div class="input-row card-number-row">
                <nz-form-item class="hcNum">
                    <nz-form-control nzHasFeedback [nzErrorTip]="hcNumErrorTpl">
                        <input
                            *ngIf="hcType === 'Ontario'"
                            nz-input
                            name="hcNum"
                            [(ngModel)]="data['hcNum']"
                            placeholder="Number i.e.1234567890"
                            required
                            minlength="10"
                            maxlength="10"
                            pattern="[0-9]*"
                        />
                        <input
                            *ngIf="hcType !== 'Ontario'"
                            nz-input
                            name="hcNum"
                            [(ngModel)]="data['hcNum']"
                            placeholder="Number"
                            required
                        />
                    </nz-form-control>
                </nz-form-item>
                <ng-template #hcNumErrorTpl let-control>
                    <div *ngIf="control.hasError('pattern')">
                        - Only numbers are allowed
                    </div>
                    <div *ngIf="control.hasError('minlength')">
                        - Health card is exactly 10 numbers
                    </div>
                    <div *ngIf="control.hasError('maxlength')">
                        - Health card numbers is exactly 10 numbers
                    </div>
                    <div *ngIf="control.hasError('required')">
                        - This field is required
                    </div>
                </ng-template>

                <nz-form-item *ngIf="hcType === 'Ontario'" class="hcVer">
                    <nz-form-control nzHasFeedback [nzErrorTip]="'Required'">
                        <input
                            nz-input
                            [(ngModel)]="data['hcVer']"
                            placeholder="XY"
                            pattern="[A-Za-z]{2}"
                            type="text"
                            name="hcVer"
                        />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div class="input-row card-dates-row">
                <nz-form-item>
                    <nz-form-label nzRequired>
                        Issue Date
                    </nz-form-label>
                    <nz-form-control nzHasFeedback [nzErrorTip]="dateErrorTpl">
                        <!-- masked -->
                        <input
                            nz-input
                            type="text"
                            [textMask]="{
                                mask: dateMask,
                                placeholderChar: '\u2000'
                            }"
                            placeholder="YYYY-MM-DD"
                            [(ngModel)]="data['hcEff']"
                            name="hcEff"
                            inputmode="numeric"
                            dateValidator
                        />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label>
                        Expiry Date
                    </nz-form-label>

                    <nz-form-control nzHasFeedback [nzErrorTip]="dateErrorTpl">
                        <input
                            nz-input
                            type="text"
                            [textMask]="{
                                mask: dateMask,
                                placeholderChar: '\u2000'
                            }"
                            placeholder="YYYY-MM-DD"
                            [(ngModel)]="data['hcExp']"
                            name="hcExp"
                            inputmode="numeric"
                            dateValidator
                        />
                    </nz-form-control>
                </nz-form-item>

                <ng-template #dateErrorTpl let-control>
                    <ng-container *ngIf="control.hasError('invalidDate')">
                        Invalid date
                    </ng-container>
                </ng-template>
            </div>
        </div>
    </div>
</div>
